import { useMemo, Children } from 'react';
import useWindowSize from 'hooks/useWindowSize';
import classNames from 'classnames';
import { getColumnCount } from './getColumnCount';
import { MasonryVerticalProps } from './types';
import useStyles from './styles';
import useMasonry from './useMasonry';

const MasonryGridVertical = ({
  children,
  columnsCount,
  gap = 10,
  containerClassName,
  dataTestId,
}: MasonryVerticalProps) => {
  const classes = useStyles();
  const { width } = useWindowSize();

  const columnCount = useMemo(() => getColumnCount({ columnsCount, width }), [columnsCount, width]);

  const { gridRef, itemRefs } = useMasonry({ children, columnCount, gap });

  return (
    <div className={classNames(classes.container, containerClassName)} data-testid={dataTestId}>
      <div className={classes.grid} ref={gridRef}>
        {Children.map(children, (child, index) => (
          <div
            ref={el => {
              itemRefs.current[index] = el;
            }}
            className={classes.item}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasonryGridVertical;
